import { FC, useEffect, useState } from "react";
import {
    StripeSchedule,
    StripePhase,
    useStripePlans,
    useStripeSchedule,
    useStripeSubscription,
    useSubscription,
} from "../../../../components/hooks";
import { useTranslation } from "react-i18next";
import { planDisplayName } from "../../../../services/StripeService";
import { IonItem, IonText } from "@ionic/react";

const CanceledMessage: FC = () => {
    const { t } = useTranslation();
    return (
        <IonItem className="ion-no-padding ion-no-margin">
            <IonText color={"danger"} style={{ fontSize: 14 }}>
                {t("cancellation.schedule.cancelled")}
            </IonText>
        </IonItem>
    );
};
const SwitchingMessage: FC<{ plan: string; date: string }> = ({
    plan,
    date,
}) => {
    const { t } = useTranslation();
    return (
        <div style={{ fontSize: "14px", color: "#aaa" }}>
            {t("cancellation.schedule.switching", {
                plan: plan,
                date: date,
            })}
        </div>
    );
};
export function useSchedulePhases() {
    const [schedule] = useStripeSchedule();
    const [firstPhase, setFirstPhase] = useState<StripePhase>();
    const [secondPhase, setSecondPhase] = useState<StripePhase>();
    useEffect(() => {
        if (!schedule) return;
        const phases = filterPhases(schedule);
        if (phases.length > 0) {
            setFirstPhase(phases[0]);
        }
        if (phases.length > 1) {
            setSecondPhase(phases[1]);
        }
    }, [schedule]);

    return [firstPhase, secondPhase];
}
export function filterPhases(schedule: StripeSchedule) {
    // Filter out past phases
    const currentStartDate = schedule.current_phase?.start_date;

    const phases = schedule.phases.filter(
        (phase) => phase.start_date >= currentStartDate
    );
    return phases;
}

export const SubscriptionSchedule: FC<{}> = () => {
    const [schedule, refresh] = useStripeSchedule();
    const subscription = useStripeSubscription();
    console.log("SUBSCRIPTION:", subscription);
    const plans = useStripePlans();
    const findPlanById = (id: string) => {
        return plans?.find((plan: any) => plan.id === id);
    };
    useEffect(() => {
        refresh();
    }, []);
    if (subscription?.rawData.cancel_at) {
        return <CanceledMessage />;
    }
    if (!schedule) {
        return <></>;
    }
    const phases = filterPhases(schedule);

    // If we have 2 phases, we can assume that the first phase is the current phase
    // and the second phase is the next phase.
    const currentPhase = phases?.[0];
    const nextPhase = phases?.[1];
    const endDate = currentPhase?.end_date;
    const nextPhasePlanId = nextPhase?.plans?.[0]?.plan;
    const nextPlan = findPlanById(nextPhasePlanId);

    return (
        <>
            {subscription?.rawData?.cancel_at && <CanceledMessage />}
            {phases && phases.length > 1 && (
                <SwitchingMessage
                    plan={planDisplayName(nextPlan)}
                    date={new Date(endDate * 1000).toLocaleDateString()}
                />
            )}
        </>
    );
};
